import script from "./PropertyDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDetailView.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDetailView.vue?vue&type=style&index=0&id=f9daf5c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9daf5c0"]])

export default __exports__